import Cal, { getCalApi } from '@calcom/embed-react';
import { useEffect } from 'react';

/**
 * Booking page component using Cal.com API
 * Allows users to schedule a demo with the Raidu team
 * 
 * @returns {JSX.Element} The rendered Booking page
 */
export default function BookingPage() {
  useEffect(() => {
    // Initialize Cal.com API with namespace
    (async function() {
      try {
        const cal = await getCalApi({"namespace":"intro"});
        cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
        console.log('Cal.com API loaded successfully');
      } catch (error) {
        console.error('Error loading Cal.com API:', error);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-4xl mx-auto mb-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-600">
            Book a Demo with Raidu
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Schedule a personalized demo to see how Raidu can help your enterprise adopt AI with security, governance, and compliance controls.
          </p>
        </div>

        <div className="w-full max-w-5xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden h-[700px] p-4 md:p-6">
          <Cal
            namespace="intro"
    calLink="raidu/intro"
            style={{width: '100%', height: '100%', overflow: 'scroll'}}
            config={{
              layout: 'month_view',
              hideBranding: 'true',
              hideEventTypeDetails: 'false',
              hideCalendarNotes: 'true'
            }}
          />
        </div>
      </div>
    </div>
  );
}
